import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { d as defineCustomElement$2 } from './progress-bar.js';

const pollAnswerCss = ".poll-answer{display:flex;flex-direction:column;row-gap:0.5rem}.poll-answer .info{display:flex;justify-content:space-between;font:var(--tt-font-standard);color:var(--tt-color-gray-900)}.poll-answer .info .count{font-variant:tabular-nums;font-feature-settings:\"tnum\"}.poll-answer .bar{--height:0.5rem;--indicator-color:var(--tt-color-gray-900)}";

const PollAnswer = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.count = undefined;
    this.percentage = undefined;
    this.label = undefined;
    this.value = undefined;
  }
  /** Call to sync the poll values in the poll */
  async update() {
    const poll = this.element.closest('tt-poll');
    if (poll) {
      const pollAnswers = poll.querySelectorAll('tt-poll-answer');
      const total = Array.from(pollAnswers).reduce((acc, cur) => {
        var _a;
        if (acc === undefined && cur === undefined) {
          return undefined;
        }
        return (acc !== null && acc !== void 0 ? acc : 0) + ((_a = cur.value) !== null && _a !== void 0 ? _a : 0);
      }, undefined);
      // no values
      if (total === undefined) {
        this.count = undefined;
        this.percentage = undefined;
        return;
      }
      if (total <= 1 && total >= 0) {
        this.count = undefined;
        this.percentage = this.value * 100;
      }
      else {
        this.count = this.value;
        this.percentage = (this.value * 100) / total;
      }
    }
    else {
      if (this.value <= 1 && this.value >= 0) {
        this.percentage = this.value * 100;
      }
      else if (this.value > 0) {
        this.count = this.value;
      }
    }
  }
  updatePoll() {
    var _a;
    (_a = this.element.closest('tt-poll')) === null || _a === void 0 ? void 0 : _a.update();
  }
  connectedCallback() {
    this.update = this.update.bind(this);
    this.update();
  }
  render() {
    return (h("div", { part: "base", class: "poll-answer" }, h("div", { class: "info" }, h("div", { class: "answer" }, this.label, this.count !== undefined && h("span", { class: "count" }, " (", this.count, ")")), h("div", { class: "percentage" }, this.percentage ? `${Math.round(this.percentage)}%` : '–')), h("tt-progress-bar", { class: "bar", percentage: this.percentage })));
  }
  get element() { return this; }
  static get watchers() { return {
    "value": ["updatePoll"]
  }; }
  static get style() { return pollAnswerCss; }
}, [1, "tt-poll-answer", {
    "label": [1],
    "value": [2],
    "count": [32],
    "percentage": [32],
    "update": [64]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-poll-answer", "tt-progress-bar"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-poll-answer":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, PollAnswer);
      }
      break;
    case "tt-progress-bar":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
  } });
}

const TtPollAnswer = PollAnswer;
const defineCustomElement = defineCustomElement$1;

export { TtPollAnswer, defineCustomElement };
